<template>
    <div>
        <div v-if="showSpinner" class="spinner-border" role="status">
            <span class="sr-only">Loading...</span>
        </div>
        <div v-else-if="historyItems.length > 0 " class="border-top border-bottom">
            <div class="row mt-2"
                 :class="idx == historyItems.length - 1 ? 'mb-2' : ''"
                 v-for="(itm, idx) in historyItemsToShow"
                 :key="idx">
                <div class="col-5 p-4">
                    <span class="historyText">{{FormatDate(itm.statusDate)}}</span>
                </div>
                <div class="col-7 border-left p-4">
                    <span class="historyText">{{itm.supplierImportRROptionStatusLabel}}</span>
                </div>
            </div>
            <div v-if="historyItems && historyItems.length > 1" class="row">
                <div class="col-12">
                    <a href="javascript:void(0);"
                       @click="showAll = !showAll"
                       class="float-right">{{ showAll == true ? '- Show less' : '+ Show more'}}</a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { repairOptionApiService } from '@/services/repairOption-api.service'
    import moment from "moment";

    export default {
        name: 'SettlementOptionHistory',
        props: {
            optionId: { required: true }
        },
        data: () => {
            return {
                loading: true,
                historyItems: [],
                showAll: true
            }
        },
        computed: {
            showSpinner() {
                if (this.historyItems.length == 0 && this.loading == true) {
                    return true;
                } else {
                    return false;
                }
            },
            historyItemsToShow() {
                if (this.showAll == true) {
                    return this.historyItems
                } else {
                    return [this.historyItems[0]]
                }
            }
        },
        methods: {
            async getStatusHistory(id) {
                try {
                    repairOptionApiService
                        .getSettlementOptionHistory(id)
                        .then(response => {
                            let { data } = response.data;
                            if (data && data.length > 0) {
                                this.historyItems = data;
                            }
                            this.loading = false;
                        })
                        .catch(err => {
                            console.log("getStatusHistory: ", err);
                        });
                } catch (err) {
                    this.loading = false;
                }
            },
            FormatDate(dte) {
                if (dte) return moment(dte).format("DD/MM/YYYY hh:mm A");

                return "UNAVAILABLE";
            }
        },
        mounted() {
            this.getStatusHistory(this.optionId);
        },
    }
</script>
<style scoped>
    .historyText {
        font-size: 1rem;
        font-weight: 300;
    }
</style>